import { z } from 'zod';

export const userLicenseSchema = z.object({
  _id: z.string().optional().nullable(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  organization: z.string().optional().nullable(),
  email: z.string().nullable(),
  phone: z.string().optional().nullable(),
  country: z.string().optional().nullable(),
  status: z.string().nullable(),
});

export const productLicenseSchema = z.object({
  name: z.string().nullable(),
  version: z.string().nullable(),
  description: z.string().nullable(),
  displayName: z.string().nullable(),
  host: z.string().nullable(),
});

export const activationSchema = z.object({
  _id: z.string().optional().nullable(),
  mac: z.string().optional().nullable(),
  permanent: z.boolean(),
  ip: z.string().optional().nullable(),
  expiration: z.string().optional().nullable(),
  created: z.string().optional().nullable(),
  renewed: z.string().optional().nullable(),
  label: z.string().optional().nullable(),
  name: z.string().optional().nullable(),
  organization: z.string().optional().nullable(),
  app: z.string().optional().nullable(),
  appVersion: z.string().optional().nullable(),
  host: z.string().optional().nullable(),
  geo: z.string().optional().nullable(),
  OS: z.string().optional().nullable(),
  memory: z.string().optional().nullable(),
  processor: z.string().optional().nullable(),
  GPU: z.string().optional().nullable(),
});

export const deactivationSchema = z.object({
  ip: z.string().optional(),
  time: z.string().optional(),
  mac: z.string().optional(),
});

export const LicenseSchema = z.object({
  serial: z.string(),
  user: userLicenseSchema,
  purchased: z.string(),
  created: z.string(),
  modified: z.string(),
  reissue: z.boolean(),
  no_activation: z.boolean(),
  no_network_checking: z.boolean(),
  valid: z.boolean(),
  active: z.boolean(),
  trial: z.boolean(),
  count: z.number(),
  // resellerCode: z.string().optional(),
  activations: activationSchema.array(),
  deactivations: deactivationSchema.array(),
  product: productLicenseSchema,
});

export type License = z.infer<typeof LicenseSchema>;

export const LicensesSchema = LicenseSchema.array();

export type Licenses = z.infer<typeof LicensesSchema>;

export const BillingAddressSchema = z.object({
  nameOnCard: z.string(),
  streetAddress: z.string(),
  locality: z.string(),
  region: z.string(),
  postalCode: z.string(),
  countryName: z.string(),
});

export const ProductSchema = z.object({
  name: z.string(),
  fullPrice: z.number(),
});

export const UserSchema = z.object({
  firstName: z.string(),
  lastName: z.string(),
});

export const EmbeddedPaymentMethodSchema = z.object({
  billingAddress: BillingAddressSchema.nullable(),
  cardType: z.string(),
});

// export const TransactionSchema = z.object({
//   _id: z.string(),
//   productId: ProductSchema,
//   userId: UserSchema.optional(),
//   status: z.string(),
//   category: z.string().optional(),
//   createdAt: z.string(),
//   quantity: z.number().optional(),
//   amount: z.number(),
//   serials: z.string().array(),
// });

// export const TransactionsSchema = TransactionDetailsSchema.array();

// export type Transactions = z.infer<typeof TransactionsSchema>;
